import { render, staticRenderFns } from "./NaoxjStockCatalog.vue?vue&type=template&id=07ab9c0c&scoped=true&"
import script from "./NaoxjStockCatalog.vue?vue&type=script&lang=js&"
export * from "./NaoxjStockCatalog.vue?vue&type=script&lang=js&"
import style0 from "./NaoxjStockCatalog.vue?vue&type=style&index=0&id=07ab9c0c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ab9c0c",
  null
  
)

export default component.exports